import React, { useEffect, useState } from 'react'
import FilterComponent from '../../../../../core/common/FilterComponent'
import AppointmentLeadSidebar from './AppointmentLeadSidebar';
import Datatable from '../../../../../core/common/dataTable';
import { leadsData } from '../../../../../core/data/json/leads';
import FilterModalAppointment from './FilterModalAppointment';
import AppointmentsResultSidebar from './AppointmentsResultSidebar';
import NoRecordFound from '../../../../../core/common/noRecord/NoRecordFound';
import { useGetAllAppointmentsQuery, useLazyGetAppointmentByIdQuery, useLazyGetAptResultByIdQuery } from '../../../../../services/EndPointsApis';
import { useTableSelection } from '../../../../../core/hooks/useTableSelection';
import TableHeading from '../../../../../core/common/tableHeading/TableHeading';
import TextField from '../../../../../core/common/textFields/TextField';
import TableLoading from '../../../../../core/common/loadingComponent/TableLoading';
import { useParams } from 'react-router-dom';
import DateComp from '../../../../../core/common/dateComponent/DateComp';

const AppointmentTab = ({ getdefaultLookups,getallActiveUsers,leadsInquirybyId }: any) => {
  const [showfilterModal, setShowfilterModal] = useState(false);
  const [appointmentTogglePopup, setAppointmentTogglePopup] = useState(false);
  const [resultsTogglePopup, setResultsTogglePopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(false);
  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(15);
  const [searchStr, setSearchStr] = useState('');
  const [isRowClicked, setIsRowClicked] = useState(false)
  const [sortBy, setSortBy] = useState("createDT");
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortedColumn, setSortedColumn] = useState("createDT");
  const [viewOnly, setViewOnly] = useState(false)
  const [isEditing, setIsEditing] = useState(false);

  const params = useParams();
  const InquiryId = params?.id

  //All Appointments API
  const { data, refetch, isLoading } = useGetAllAppointmentsQuery({
    pageNumber: pageNumber,
    pageSize: pageSize,
    searchStr: searchStr || ' ',
    sortBy: sortBy,
    sortOrder: sortOrder,
    LeadInquiry: InquiryId
  });

  const [TriggerApt, { data: aptbyId, isLoading: aptIsLoading }] = useLazyGetAppointmentByIdQuery()
  const [TriggerAptResult, { data: aptResultbyId }] = useLazyGetAptResultByIdQuery()


  //Table CustomHook
  const {
    isTableHeadChecked,
    selectedIndividualCheckboxId,
    selectedItemData: AptData,
    handleTableHeadChange,
    handleCheckItem,
    handleRowClick,
    handleRowDoubleClick
  } = useTableSelection(data?.result?.data || [], 'appointmentId');

  const closeSidebar = () => {
    setAppointmentTogglePopup(false);
    setResultsTogglePopup(false)
    refetch()
  };

  const handleAddAppointments = () => {
    setAppointmentTogglePopup(true)
    setIsEditing(false)
  }
  const handleResults = () => {
    setResultsTogglePopup(true)
    setViewOnly(false);

  }
  const handleViewResults = () => {
    setResultsTogglePopup(true)
    setViewOnly(true);

  }
  const handleEditAppointments = () => {
    setAppointmentTogglePopup(true)
    setIsEditing(true)
    setViewOnly(false);

  }
  const handleClosefilterModal = () => {
    setShowfilterModal(false)
  }
  const handleSort = (property: string) => {
    setSortBy(property);
    if (sortedColumn === property) {
      setSortOrder(prevSortOrder => (prevSortOrder === "asc" ? "desc" : "asc"));
    } else {
      setSortedColumn(property);
      setSortOrder("asc");
    }
    // Perform additional sorting logic...
  };

  const idValue = 'dropdownMenuClickableInsise1';

  const handlefiltermodel = () => {
    setShowfilterModal(true);
    const dropdownToggle = document.getElementById(idValue);
    if (dropdownToggle) {
      dropdownToggle.click();
    }
  }

  useEffect(() => {
    if (searchStr === "" ||
      sortOrder === "" ||
      sortBy === "") {
      refetch();
    }
  }, [searchStr, sortOrder, sortBy]);

  const handleRowClicked = (data: any) => {
    handleRowClick(data);
    setIsRowClicked(true);
  }
  const handleDoubleClick = (items: any) => {
    handleRowDoubleClick(items);
    setViewOnly(true);
  };
  const isAnyCheckboxChecked = selectedIndividualCheckboxId.length > 0;
  const isMoreThanOneChecked = selectedIndividualCheckboxId.length > 1;
  return (
    <>
      <FilterModalAppointment show={showfilterModal} handleClose={handleClosefilterModal} />
      <AppointmentsResultSidebar activityTogglePopup={resultsTogglePopup} viewOnly={viewOnly} TriggerAptResult={TriggerAptResult} aptResultbyId={aptResultbyId} closeSidebar={closeSidebar} isEditing={isEditing} selectedIndividualCheckboxId={selectedIndividualCheckboxId} InquiryId={InquiryId} />
      <AppointmentLeadSidebar getdefaultLookups={getdefaultLookups} TriggerApt={TriggerApt} 
      aptbyId={aptbyId} activityTogglePopup={appointmentTogglePopup} 
      closeSidebar={closeSidebar} isEditing={isEditing} 
      selectedIndividualCheckboxId={selectedIndividualCheckboxId} 
      InquiryId={InquiryId} getallActiveUsers={getallActiveUsers} />
      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body p-2'>
              <div className='d-flex justify-content-between align-items-center mb-2'>
                <h5>Appointments</h5>
                <div className='d-flex gap-3'>
                  <>
                    <button type='button' className='btn ' disabled={!isAnyCheckboxChecked || isMoreThanOneChecked} onClick={handleViewResults}>
                      View Result
                    </button>
                    <button type='button' className='btn btnribbon2' disabled={!isAnyCheckboxChecked || isMoreThanOneChecked} onClick={handleResults}>
                      Results
                    </button>
                    {selectedIndividualCheckboxId[0] ?
                      <button type='button' className='btn btn-primary px-3' disabled={isMoreThanOneChecked} onClick={handleEditAppointments}>
                        Edit
                      </button>
                      :
                      <button type='button' className='btn btn-primary ' disabled={isMoreThanOneChecked} onClick={handleAddAppointments}>
                        + New Appointment
                      </button>
                    }
                  </>
                  <>
                    <FilterComponent handlefiltermodel={handlefiltermodel} idValue={idValue} />
                  </>
                  <div>
                    <div className=" icon-form ">
                      <span className="form-icon">
                        <i className="ti ti-search" />
                      </span>
                      <input
                        type="text"
                        className="form-control  h-teams"
                        placeholder="Search Apt"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive custom-tableApt" >
                <table className="table datanew dataTable no-footer table-hover">
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          className='form-check-input cursor-pointer'
                          checked={isTableHeadChecked}
                          onChange={handleTableHeadChange}
                        />
                      </th>
                      <TableHeading
                        label='ID'
                        sortedColumn='recordNumber'
                        columnId='recordNumber'
                        sortOrder='desc'
                        key='userId'
                        handleSort={handleSort}
                      />
                      <TableHeading
                        label='Apt Title'
                        sortedColumn='aptTitle'
                        columnId='aptTitle'
                        sortOrder='desc'
                        key='userId'
                        handleSort={handleSort}
                      />
                      <TableHeading
                        label='APPOINTMENT TYPE'
                        sortedColumn='lst_AppointmentTypeName'
                        columnId='lst_AppointmentTypeName'
                        sortOrder='desc'
                        handleSort={handleSort}
                      />
                      <TableHeading
                        label='DURATION'
                        sortedColumn='lst_FreshAptDurationName'
                        columnId='lst_FreshAptDurationName'
                        sortOrder='desc'
                        handleSort={handleSort}
                      />

                      <TableHeading
                        label='START TIME'
                        sortedColumn='startTime'
                        columnId='startTime'
                        sortOrder='desc'
                        handleSort={handleSort}
                      />
                      <TableHeading
                        label='END TIME'
                        sortedColumn='endTime'
                        columnId='endTime'
                        sortOrder='desc'
                        handleSort={handleSort}
                      />
                    </tr>
                  </thead>
                  <tbody>
                    {!isLoading && <>
                      {data?.result?.data?.length > 0 ? (
                        <>
                          {data?.result?.data?.map((data: any, index: any) => (
                            <tr key={data?.appointmentId} onClick={() => handleRowClicked(data)} onDoubleClick={() => handleDoubleClick(data)}
                              className={selectedIndividualCheckboxId.includes(data?.appointmentId) ? 'selected-row' : ''}>
                              <td>
                                <TextField
                                  type="checkbox"
                                  fieldClass='form-check-input cursor-pointer'
                                  checked={isTableHeadChecked || selectedIndividualCheckboxId.includes(data.appointmentId)}
                                  onChange={(e) => handleCheckItem(e, data)}
                                />
                              </td>
                              <td>{data?.recordNumber}</td>
                              <td>{data?.aptTitle}</td>
                              <td>{data?.lst_AppointmentTypeName}</td>
                              <td>{data?.lst_FreshAptDurationName}</td>
                              <td>{data?.startTime}</td>
                              <td>{data?.endTime}</td>
                              
                            </tr>
                          ))}
                        </>
                      ) :
                        (
                          <tr>
                            <td colSpan={7}>
                              <NoRecordFound />
                            </td>
                          </tr>
                        )}
                    </>}
                    {isLoading &&
                      <TableLoading />
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}

export default AppointmentTab